/* ============================================================
   Vurozen — Collection Template JS
   hw40-collection.js
   ============================================================ */

(function () {
  'use strict';

  /* Pre-declare drawer so attachSwipeClose can reference it */
  var drawer  = document.getElementById('hw40FilterDrawer');
  var overlay = document.getElementById('hw40FilterOverlay');

  /* ── 1. PREMIUM DROPDOWN SYSTEM (.hw40-dd) ────────────────── */

  var allDD = document.querySelectorAll('[data-hw40-dd]');

  function closeAllDD() {
    allDD.forEach(function (dd) {
      dd.classList.remove('is-open');
      var t = dd.querySelector('.hw40-dd__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  /**
   * Apply a filter by updating URL search params and navigating.
   * @param {HTMLElement} dd   - the .hw40-dd wrapper
   * @param {string}      val  - the selected value (empty = "All"/reset)
   */
  function applyFilter(dd, val) {
    var param  = dd.dataset.param  || 'sort_by';
    var prefix = dd.dataset.prefix || '';
    var url    = new URL(window.location.href);

    if (param === 'sort_by') {
      if (val && val !== 'manual') {
        url.searchParams.set('sort_by', val);
      } else {
        url.searchParams.delete('sort_by');
      }
    } else {
      /* Tag-based param (filter.p.tag) — remove only entries with our prefix */
      var existing = url.searchParams.getAll(param);
      url.searchParams.delete(param);
      existing.forEach(function (v) {
        if (v.indexOf(prefix) !== 0) {
          /* Keep params that belong to other filter groups */
          url.searchParams.append(param, v);
        }
      });
      if (val) {
        url.searchParams.append(param, prefix + val);
      }
      /* Always reset to page 1 when filtering */
      url.searchParams.delete('page');
    }

    window.location.href = url.toString();
  }

  /* ──────────────────────────────────────────────────────────
     Inject drag handle + close header into every dd menu.
     On desktop: handle is hidden (CSS display:none).
     On mobile:  handle shows as pill; swipe-down or tap closes.
     ────────────────────────────────────────────────────────── */
  allDD.forEach(function (dd) {
    var menu = dd.querySelector('.hw40-dd__menu');
    if (!menu) return;

    /* Get label from parent .collection-filter > span */
    var filterEl  = dd.closest('.collection-filter');
    var titleText = (filterEl && filterEl.querySelector('span'))
      ? filterEl.querySelector('span').textContent.trim()
      : (dd.dataset.hw40Dd || '');

    /* 1. Drag handle pill */
    var handleWrap = document.createElement('div');
    handleWrap.className = 'hw40-sheet-handle-wrap';
    handleWrap.innerHTML = '<div class="hw40-sheet-handle"></div>';
    menu.prepend(handleWrap);

    /* 2. Title + close row (mobile sheet header) */
    var header = document.createElement('div');
    header.className = 'hw40-dd__sheet-header';
    header.innerHTML =
      '<span class="hw40-dd__sheet-title">' + titleText + '</span>' +
      '<button type="button" class="hw40-dd__sheet-close" aria-label="Close">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
          '<line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/>' +
        '</svg>' +
      '</button>';
    menu.insertBefore(header, handleWrap.nextSibling);

    header.querySelector('.hw40-dd__sheet-close').addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllDD();
    });

    /* Swipe-down to close */
    attachSwipeClose(handleWrap, closeAllDD, menu);
  });

  /* Swipe-down close for the filter drawer handle on mobile */
  var filterHandle = document.getElementById('hw40FilterHandle');
  if (filterHandle) {
    filterHandle.addEventListener('click', function () { closeDrawer(); });
    attachSwipeClose(filterHandle, function () { closeDrawer(); }, drawer);
  }

  /**
   * Attach drag-down-to-close behavior to a handle element.
   * @param {Element} handle      The pill/handle element
   * @param {Function} closeFn    Called when threshold drag is reached
   * @param {Element} sheetEl     The sheet element to transform during drag
   */
  function attachSwipeClose(handle, closeFn, sheetEl) {
    var startY   = 0;
    var dragging = false;

    handle.addEventListener('touchstart', function (e) {
      startY   = e.touches[0].clientY;
      dragging = true;
      if (sheetEl) sheetEl.style.transition = 'none';
    }, { passive: true });

    handle.addEventListener('touchmove', function (e) {
      if (!dragging || !sheetEl) return;
      var delta = e.touches[0].clientY - startY;
      if (delta > 0) {
        sheetEl.style.transform = 'translateY(' + delta + 'px)';
      }
    }, { passive: true });

    handle.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      if (!sheetEl) { closeFn(); return; }
      var delta = e.changedTouches[0].clientY - startY;
      sheetEl.style.transition = '';
      sheetEl.style.transform  = '';
      if (delta > 60) {
        closeFn();
      }
    });
  }

  allDD.forEach(function (dd) {
    var trigger = dd.querySelector('.hw40-dd__trigger');
    var label   = dd.querySelector('.hw40-dd__label');
    var opts    = dd.querySelectorAll('.hw40-dd__opt');

    if (!trigger || !label) return;

    /* Open / close toggle */
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !dd.classList.contains('is-open');
      closeAllDD();
      if (willOpen) {
        dd.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    /* Option selection */
    opts.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        var val = opt.getAttribute('data-value') || '';

        /* Update label to selected option text */
        label.textContent = opt.textContent.trim();

        /* Update aria-selected */
        opts.forEach(function (o) { o.removeAttribute('aria-selected'); });
        opt.setAttribute('aria-selected', 'true');

        closeAllDD();
        applyFilter(dd, val);
      });
    });
  });

  /* Close on outside click or Escape */
  document.addEventListener('click', closeAllDD);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllDD(); closeDrawer(); }
  });

  /* ── 2. FILTER PANEL (full drawer) ───────────────────────── */

  function openDrawer() {
    if (!drawer) return;
    closeAllDD();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.classList.add('hw40-no-scroll');
    document.body.classList.add('hw40-no-scroll');
    var closeEl = drawer.querySelector('.hw40-filter-drawer__close');
    if (closeEl) closeEl.focus();
    syncDrawerFromUrl();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.classList.remove('hw40-no-scroll');
    document.body.classList.remove('hw40-no-scroll');
  }

  document.querySelectorAll('[data-hw40-open-filter]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.stopPropagation(); openDrawer(); });
  });

  if (overlay) overlay.addEventListener('click', closeDrawer);

  var drawerCloseBtn = drawer && drawer.querySelector('.hw40-filter-drawer__close');
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);

  /* Collapsible groups (−) */
  document.querySelectorAll('.hw40-filter-group__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var group     = toggle.closest('.hw40-filter-group');
      var collapsed = group.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', String(!collapsed));
    });
  });

  /* Sync drawer radios from current URL params */
  function syncDrawerFromUrl() {
    if (!drawer) return;
    var url     = new URL(window.location.href);
    var tagVals = url.searchParams.getAll('filter.p.tag');
    var allRadios = drawer.querySelectorAll('.hw40-filter-radio');

    /* Reset all to "All" */
    var groups = {};
    allRadios.forEach(function (r) {
      if (!groups[r.name]) groups[r.name] = [];
      groups[r.name].push(r);
      r.checked = false;
    });
    Object.keys(groups).forEach(function (gname) {
      var allOpt = drawer.querySelector('input[name="' + gname + '"][value=""]');
      if (allOpt) allOpt.checked = true;
    });

    /* Mark active tags */
    tagVals.forEach(function (tag) {
      var r = drawer.querySelector('input[value="' + tag + '"]');
      if (r) {
        var allOpt = drawer.querySelector('input[name="' + r.name + '"][value=""]');
        if (allOpt) allOpt.checked = false;
        r.checked = true;
      }
    });

    /* Price */
    var gte = url.searchParams.get('filter.v.price.gte');
    var lte = url.searchParams.get('filter.v.price.lte');
    var minEl = document.getElementById('hw40PriceMin');
    var maxEl = document.getElementById('hw40PriceMax');
    if (minEl && gte) minEl.value = gte;
    if (maxEl && lte) maxEl.value = lte;
  }

  /* Apply Filters */
  var applyBtn = document.getElementById('hw40FilterApply');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var url = new URL(window.location.href);
      url.searchParams.delete('filter.p.tag');
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.delete('page');

      var groups = ['hw40-goal', 'hw40-ritual', 'hw40-cat'];
      groups.forEach(function (gname) {
        var checked = drawer ? drawer.querySelector('input[name="' + gname + '"]:checked') : null;
        if (checked && checked.value !== '') {
          url.searchParams.append('filter.p.tag', checked.value);
        }
      });

      var priceMin = document.getElementById('hw40PriceMin');
      var priceMax = document.getElementById('hw40PriceMax');
      if (priceMin && priceMin.value) url.searchParams.set('filter.v.price.gte', priceMin.value);
      if (priceMax && priceMax.value) url.searchParams.set('filter.v.price.lte', priceMax.value);

      window.location.href = url.toString();
    });
  }

  /* Clear all filters */
  var clearBtn = document.getElementById('hw40FilterClear');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      var baseUrl = clearBtn.dataset.clearUrl || window.location.pathname;
      var sort    = new URL(window.location.href).searchParams.get('sort_by');
      window.location.href = baseUrl + (sort ? '?sort_by=' + sort : '');
    });
  }

  /* Highlight the currently active option on page load (URL state) */
  (function syncActiveOptions() {
    var url = new URL(window.location.href);

    allDD.forEach(function (dd) {
      var param  = dd.dataset.param  || 'sort_by';
      var prefix = dd.dataset.prefix || '';
      var label  = dd.querySelector('.hw40-dd__label');
      var opts   = dd.querySelectorAll('.hw40-dd__opt');
      if (!label) return;

      var activeVal = '';

      if (param === 'sort_by') {
        activeVal = url.searchParams.get('sort_by') || 'manual';
      } else {
        var tagVals = url.searchParams.getAll(param);
        tagVals.forEach(function (v) {
          if (v.indexOf(prefix) === 0) {
            activeVal = v.slice(prefix.length);
          }
        });
      }

      if (!activeVal) return;

      opts.forEach(function (opt) {
        var val = opt.getAttribute('data-value') || '';
        if (val === activeVal) {
          opt.setAttribute('aria-selected', 'true');
          label.textContent = opt.textContent.trim();
        }
      });
    });
  })();

  /* ── 3. COLUMN TOGGLE (3 / 4 cols) ───────────────────────── */

  var grid = document.getElementById('hw40-products-grid');

  document.querySelectorAll('[data-hw40-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cols = btn.dataset.hw40Cols;

      document.querySelectorAll('[data-hw40-cols]').forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.hw40Cols === cols);
      });

      if (grid) {
        grid.classList.toggle('cols-4', cols === '4');
      }

      try { localStorage.setItem('hw40-grid-cols', cols); } catch (e) {}
    });
  });

  /* Restore saved column preference */
  (function () {
    try {
      var saved = localStorage.getItem('hw40-grid-cols');
      if (saved && grid) {
        grid.classList.toggle('cols-4', saved === '4');
        document.querySelectorAll('[data-hw40-cols]').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.hw40Cols === saved);
        });
      }
    } catch (e) {}
  })();

  /* ── 3. AJAX ADD TO CART ──────────────────────────────────── */

  function initAddToCart() {
    document.querySelectorAll('.hw40-col-card__add:not([data-bound])').forEach(function (btn) {
      btn.setAttribute('data-bound', '1');

      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;

        btn.classList.add('is-loading');
        btn.textContent = '…';

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
          });

          if (res.ok) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

            /* Notify Dawn cart drawer */
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = '+';
            }, 2200);
          } else {
            btn.classList.remove('is-loading');
            btn.textContent = '+';
            var productUrl = btn.dataset.productUrl;
            if (productUrl) window.location.href = productUrl;
          }
        } catch (err) {
          btn.classList.remove('is-loading');
          btn.textContent = '+';
        }
      });
    });
  }

  initAddToCart();

  /* ── 4. AJAX LOAD MORE ────────────────────────────────────── */

  var loadMoreBtn = document.getElementById('hw40LoadMoreBtn');

  if (loadMoreBtn && grid) {
    loadMoreBtn.addEventListener('click', async function () {
      var nextUrl = loadMoreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      loadMoreBtn.classList.add('is-loading');
      loadMoreBtn.setAttribute('aria-disabled', 'true');

      try {
        var res  = await fetch(nextUrl);
        var html = await res.text();
        var parser   = new DOMParser();
        var doc      = parser.parseFromString(html, 'text/html');
        var newCards = doc.querySelectorAll('.hw40-col-card');

        newCards.forEach(function (card) {
          grid.appendChild(card.cloneNode(true));
        });

        initAddToCart();

        var newBtn = doc.getElementById('hw40LoadMoreBtn');
        if (newBtn && newBtn.dataset.nextUrl) {
          loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
        } else {
          loadMoreBtn.style.display = 'none';
        }

        var newCount = doc.querySelector('[data-hw40-count]');
        var curCount = document.querySelector('[data-hw40-count]');
        if (newCount && curCount) {
          curCount.textContent = newCount.textContent;
        }
      } catch (err) {
        console.warn('[hw40-collection] Load more error:', err);
      }

      loadMoreBtn.classList.remove('is-loading');
      loadMoreBtn.removeAttribute('aria-disabled');
    });
  }

  /* ── 5. TAB HIGHLIGHT (current collection) ────────────────── */
  (function () {
    var currentHandle = document.documentElement.dataset.collection || '';
    document.querySelectorAll('.hw40-col-tabs__item').forEach(function (tab) {
      if (tab.dataset.handle === currentHandle) {
        tab.classList.add('is-active');
      }
    });
  })();

})();
